import { render } from "./TopThreeExample.vue?vue&type=template&id=cdb779b2&scoped=true"
import script from "./TopThreeExample.vue?vue&type=script&lang=js"
export * from "./TopThreeExample.vue?vue&type=script&lang=js"

import "./TopThreeExample.vue?vue&type=style&index=0&id=cdb779b2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kevin\\Desktop\\AirFryer\\AirFryer_Berater\\AirFryer_Kaufberatung\\form_try0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdb779b2"]])

export default __exports__